// ──────────────────────────────────────────────────────────────────────────────
// MENU v2 (orienté TÂCHES) — variante en test, rendue parallèlement au menu live
// (cf. SideBar.js + toggle). Reprend les routes/droits réels de sideBarUtils.js et
// ajoute le module « Réseau de distribution » (création/suivi agence, accréditation/
// suivi courtier).
//
// NB : le « Suivi agence » (CA, commissions, primes reversées/non reversées) se présente
// sous forme d'ONGLETS dans la page agence (/agence) — le dashboard agrégé est un
// chantier dédié (endpoint à venir). L'entrée de menu est déjà branchée.
// ──────────────────────────────────────────────────────────────────────────────
import {
    ApartmentOutlined, AppstoreOutlined, BankOutlined, BarChartOutlined, BranchesOutlined,
    ControlOutlined, CreditCardOutlined, CustomerServiceOutlined, DollarOutlined,
    ExclamationCircleOutlined, HomeOutlined, SafetyOutlined, SolutionOutlined,
    SyncOutlined, UnorderedListOutlined,
} from "@ant-design/icons";
import { LOGGED_USER } from "../variables/constants";

const isPool = LOGGED_USER?.profil?.organisme?.typeOrganisme === "POOL";
const isSiege = LOGGED_USER?.profil?.organisme?.typeOrganisme === "SIEGE";

const attestationsConsultLink = isPool ? "/gestion-des-attestations" : "/mes-attestations";
const attestationsCommandesLink = isPool ? "/compagnies-commandes" : isSiege ? "/nos-commandes" : "/commandes";

export const menuItemsV2 = [
    {
        key: "DASHBOARD",
        icon: <HomeOutlined style={{ fontSize: "18px" }} />,
        label: "Tableau de bord",
        link: "/#",
        right: "",
    },

    // ── PRODUCTION ────────────────────────────────────────────────────────────
    {
        key: "PRODUCTION",
        icon: <AppstoreOutlined style={{ fontSize: "18px" }} />,
        label: "Production",
        children: [
            { key: "v2-prod-new", label: "Nouveau contrat", link: "/ajouter-contrat-new", right: "" },
            { key: "v2-prod-all", label: "Tous les contrats", link: "/production/v3", right: "HCO020" },
            { key: "v2-prod-prop", label: "Continuer une proposition", link: "/propositions", right: "HCO020" },
            { key: "v2-prod-assures", label: "Liste des assurés", link: "/assures", right: "HCL024" },
            { key: "v2-prod-etats", label: "États de production", link: "/etats/production-globale", right: "HET023" },
            { key: "v2-sin-commission-tech-prod", label: "Commission technique production", link: "/commission-technique-production", right: "HSI111" },
        ],
        right: "HCO020",
    },

    // ── ATTESTATIONS ──────────────────────────────────────────────────────────
    {
        key: "ATTESTATION",
        icon: <UnorderedListOutlined style={{ fontSize: "18px" }} />,
        label: "Attestations",
        children: [
            { key: "v2-att-cmd", label: "Commander les attestations", link: attestationsCommandesLink, right: "" },
            { key: "v2-att-consult", label: "Consulter les attestations", link: attestationsConsultLink, right: "" },
            { key: "v2-att-cedeao-etat", label: "État attestations CEDEAO imprimées", link: "/attestations-cedeao-imprimees", right: "HCO007" },
            { key: "v2-att-cima-etat", label: "État attestations CIMA imprimées", link: "/attestations-cima-imprimees", right: "HCO069" },
        ],
        right: "HCO069",
    },

    // ── CAISSE ────────────────────────────────────────────────────────────────
    {
        key: "CAISSE",
        icon: <DollarOutlined style={{ fontSize: "18px" }} />,
        label: "Caisse",
        children: [
            { key: "v2-caisse-encaisser", label: "Encaisser une prime", link: "/en-attente-d-encaissement/v2", right: "HCO008" },
            { key: "v2-caisse-enc", label: "Consulter / Annuler mes encaissements", link: "/encaissements/v2", right: "HCO008" },
            { key: "v2-caisse-mobile", label: "Encaissements mobiles reçus", link: "/transactions-mobile-money", right: "HLA087" },
            { key: "v2-caisse-bord-revers", label: "Encaisser un bordereau de reversement", link: "/borderaux-de-versement-en-compagnie", right: "HCO008" },
            { key: "v2-caisse-etat-caissier", label: "État de caisse par caissier", link: "/caisse/etat-caissier", right: "HCO008" },
        ],
        right: "HCO008",
    },

    // ── REVERSEMENT DE PRIMES ─────────────────────────────────────────────────
    {
        key: "REVERSEMENT",
        icon: <CreditCardOutlined style={{ fontSize: "18px" }} />,
        label: "Reversement de primes",
        children: [
            { key: "v2-rev-create", label: "Créer un bordereau de reversement", link: "/versements-en-compagnie", right: "HCO008" },
            { key: "v2-rev-vt", label: "Enregistrer un reversement (STCA, GUM)", link: "/vt/versements-bancaires", right: "HLA086" },
            { key: "v2-rev-list", label: "Mes reversements de primes", link: "/borderaux-de-versement-en-compagnie", right: "" },
        ],
        right: "HCO008",
    },

    // ── COMMISSIONS ───────────────────────────────────────────────────────────
    {
        key: "COMMISSION",
        icon: <BankOutlined style={{ fontSize: "18px" }} />,
        label: "Commissions",
        children: [
            { key: "v2-com-gen", label: "Générer un bordereau de commission", link: "/commissions-generees", right: "" },
            { key: "v2-com-bord", label: "Bordereaux de commissions", link: "/bordereaux", right: "" },
            { key: "v2-com-mine", label: "Mes commissions (Agence, courtier)", link: "/bordereaux", right: "" },
            { key: "v2-com-recalcul", label: "Recalculer les commissions", link: "/commissions/recalcul", right: "HCO020" },
        ],
        right: "HCO020",
    },

    // ── RÉSEAU DE DISTRIBUTION (NOUVEAU) ──────────────────────────────────────
    {
        key: "RESEAU",
        icon: <ApartmentOutlined style={{ fontSize: "18px" }} />,
        label: "Réseau de distribution",
        children: [
            { key: "v2-reseau-agence-new", label: "Création d'agence", link: "/ma-compagnie?tab=agences", right: "HME050" },
            { key: "v2-reseau-agence-suivi", label: "Suivi des agences", link: "/reseau/suivi-agences", right: "HME050" },
            { key: "v2-reseau-courtier-new", label: "Accréditation des courtiers", link: "/reseau/accreditation-courtiers", right: "HME050" },
            { key: "v2-reseau-courtier-suivi", label: "Suivi des courtiers", link: "/reseau/suivi-courtiers", right: "HME050" },
            { key: "v2-reseau-intermediaires", label: "Suivi des commerciaux", link: "/reseau/suivi-intermediaires", right: "HME050" },
            { key: "v2-reseau-taux", label: "Taux de commissions", link: "/parametres/taux-commissions/v2", right: "HPA032" },
        ],
        right: "HME050",
    },

    // ── SINISTRES ─────────────────────────────────────────────────────────────
    {
        key: "SINISTRES",
        icon: <ExclamationCircleOutlined style={{ fontSize: "18px" }} />,
        label: "Sinistres",
        children: [
            { key: "v2-sin-decl", label: "Déclarer un sinistre", link: "/declarer-sinister", right: "HSI027" },
            { key: "v2-sin-list", label: "Instruire un dossier", link: "/liste-des-sinistres", right: "HSI027" },
            // Vérification des pièces déposées depuis le mobile. Même règle que l'écran et que le
            // backend : le Pool y a droit implicitement, les autres via HJP001. rightsService ne
            // sait tester qu'un code d'habilitation, d'où le `right` conditionnel plutôt qu'un
            // "HJP001" sec, qui masquerait l'entrée aux profils Pool ne portant pas le code.
            { key: "v2-sin-justif", label: "Justificatifs de paiements", link: "/verification-justificatifs", right: isPool ? "" : "HJP001" },
            { key: "v2-sin-inventaires", label: "Inventaires de réévaluation", link: "/inventaires", right: "HSI116" },
            {
                key: "v2-sin-listings",
                label: "Listings et états",
                right: "HSI027",
                children: [
                    { key: "v2-sin-evals", label: "Listing des évaluations", link: "/validation-evaluation/v2", right: "HSI027" },
                    { key: "v2-sin-sap", label: "Listing des SAP", link: "/stats/sap-sinistres", right: "HSI027" },
                    { key: "v2-sin-regl", label: "Listing des règlements", link: "/validation-decaissement/v2", right: "HSI027" },
                    { key: "v2-sin-commission-tech", label: "Commission technique sinistre", link: "/commission-technique", right: "HPA109" },
                    { key: "v2-sin-recours", label: "Listing des recours", link: "/listing-des-recours", right: "HSI027" },
                    { key: "v2-sin-payes-comp", label: "Sinistres payés par compagnie", link: "/etats/sinistres-payes-compagnie", right: "HSI027" },
                    { key: "v2-sin-etats", label: "Divers états des sinistres", link: "/etats/sinistres", right: "HSI027" },
                    { key: "v2-sin-regul-sap", label: "Régularisation SAP compagnies", link: "/regularisation-sap", right: "HSI115" },
                ],
            },
        ],
        right: "HSI027",
    },

    // ── CESSION & RÉTROCESSION ────────────────────────────────────────────────
    {
        key: "OPERATIONS",
        icon: <BranchesOutlined style={{ fontSize: "18px" }} />,
        label: "Cession & Rétrocession",
        children: [
            { key: "v2-op-cession", label: "Consulter une cession", link: "/toutes-les-cessions", right: "HOP028" },
            { key: "v2-op-retro", label: "Consulter une rétrocession", link: "/retrocessions", right: "HOP028" },
            { key: "v2-op-cles-retro", label: "Clés de rétrocession", link: "/cles-de-retrocession", right: "HOP028" },
            { key: "v2-op-emissions-reportees", label: "Émissions reportées", link: "/emissions-reportees", right: "HOP028" },
        ],
        right: "HOP028",
    },

    // ── COMPTABILITÉ ──────────────────────────────────────────────────────────
    {
        key: "COMPTABILITE",
        icon: <CreditCardOutlined style={{ fontSize: "18px" }} />,
        label: "Comptabilité",
        children: [
            { key: "v2-compta-comptes", label: "Comptes", link: "/comptabilite/comptes", right: "HLA029" },
            { key: "v2-compta-livre", label: "Écritures comptables", link: "/comptabilite/grand-livre", right: "HLA029" },
            { key: "v2-compta-balance", label: "Balance", link: "/comptabilite/balance", right: "HLA029" },
            { key: "v2-stats-prec", label: "Primes à reporter", link: "/stats/primes-a-reporter", right: "HET023" },
            {
                key: "v2-compta-fiscalite",
                label: "Fiscalité",
                right: "HLA029",
                children: [
                    { key: "v2-fisc-tca", label: "TCA à reverser", link: "/comptabilite/fiscalite/tca", right: "HLA029" },
                    { key: "v2-fisc-honoraires", label: "Retenues sur honoraires", link: "/comptabilite/fiscalite/honoraires", right: "HLA029" },
                    { key: "v2-fisc-commissions", label: "Retenues sur commissions", link: "/comptabilite/fiscalite/commissions", right: "HLA029" },
                ],
            },
        ],
        right: "HLA029",
    },

    // ── STATISTIQUES & ÉTATS ──────────────────────────────────────────────────
    {
        key: "STATS",
        icon: <BarChartOutlined style={{ fontSize: "18px" }} />,
        label: "Statistiques & États",
        children: [
            { key: "v2-stats-prod", label: "États de production", link: "/etats/production-globale", right: "HET023" },
            { key: "v2-stats-agence", label: "Stats production (agence)", link: "/stats/agence-prod", right: "HET023" },
            { key: "v2-stats-prec", label: "Primes à reporter", link: "/stats/primes-a-reporter", right: "HET023" },
            { key: "v2-stats-sin", label: "Divers états sinistres", link: "/etats/sinistres", right: "HET023" },
        ],
        right: "HET023",
    },

    // ── PARAMÉTRAGE ───────────────────────────────────────────────────────────
    {
        key: "PARAMETRES",
        icon: <ControlOutlined style={{ fontSize: "18px" }} />,
        label: "Paramétrage",
        children: [
            { key: "v2-param-tarif", label: "Paramètres de Tarification", link: "/tarification/v2", right: "HPA031" },
            { key: "v2-param-sin", label: "Paramètres sinistres", link: "/parametres/sinistres", right: "HPA085" },
            { key: "v2-param-compta", label: "Paramètres Comptabilité", link: "/comptabilite/parametrage", right: "HLA029" },
            { key: "v2-param-compagnie", label: "Ma compagnie", link: "/ma-compagnie", right: "HME050" },
            { key: "v2-param-autres", label: "Autres paramètres", link: "/autres-parametres", right: "HPA032" },
        ],
        right: "HPA032",
    },

    // ── DROITS & SÉCURITÉ ─────────────────────────────────────────────────────
    {
        key: "DROITS",
        icon: <SafetyOutlined style={{ fontSize: "18px" }} />,
        label: "Droits & Sécurité",
        children: [
            { key: "v2-droits-users", label: "Créer les utilisateurs", link: "/utilisateurs", right: "HPE033" },
            { key: "v2-droits-profils", label: "Créer les profils", link: "/profils", right: "HAC034" },
            { key: "v2-droits-hab", label: "Habilitations", link: "/habilitations", right: "HAC035" },
            { key: "v2-droits-journal", label: "Journal des activités", link: "/activity-logs", right: "HPE033" },
            { key: "v2-droits-appareils", label: "Appareils des utilisateurs", link: "/securite/appareils", right: "HAC113" },
            { key: "v2-droits-sync", label: "Synchronisation des données", link: "/synchronisations", right: "HLA083" },
        ],
        right: "HPE033",
    },

    {
        key: "SUPPORT",
        icon: <CustomerServiceOutlined style={{ fontSize: "18px" }} />,
        label: "Support",
        link: "https://ossansupport.oapps.net/",
    },
    // {
    //     key: "DOCUMENTATION",
    //     icon: <FileTextOutlined style={{ fontSize: "18px" }} />,
    //     label: "Documentation",
    //     link: "https://ossanasur.com/poolins/documentation/",
    // },

    // Icône réservée (Solution/Sync) pour usage futur des sous-modules réseau.
    // eslint-disable-next-line no-unused-vars
];

// Icônes importées et réservées pour évolutions (évite un import inutilisé bloquant).
export const _v2ReservedIcons = { SolutionOutlined, SyncOutlined };
